import Image from 'app/Components/Shared/Image/image';
import React, { useEffect } from 'react';
import Config from '../../../../../Config';
import EpiContext from '@episerver/spa-core/Spa';
import { prepareUrl } from '../../../../../utilities/StringHelpers/StringHelpers';
import BtnWhiteBlackBorderBigSize from '../../../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import { connect } from 'react-redux';
import { setSelectedSubscriber } from '../../ConnectionDetailsBlockSlice';
import {getIspConnectionDetailsAsync} from '../../ConnectionDetailsBlockAsyncThunk';
import AlertIcon from '../../images/alert-icon.svg';

const CustomerServiceMessagesPage = (props) => {
    let title = null;
    let subTitle = null;
    let btnText = '';
    let linkText = '';
    let link = null;
    let btnLink = null;
    let image = AlertIcon;
    let displayCallBack = false;

    switch (props.customerServiceMessageType) {
        case 'SUBSCRIBER_NOT_FOUND':
            image = AlertIcon;
            title = `מצטערים, אנחנו לא מזהים שיש לכם שירות אינטרנט ב${window.Config.brand_Name_HE}`;
            subTitle = 'יכול להיות שנרשמתם עם פרטים אחרים? שווה לנסות להתחבר שוב';
            linkText = 'לחצו כאן להצטרפות לשירות';
            link = props.linkJoinToService;
            btnLink = Config.lobbyUrl;
            btnText = 'חזרה לאיזור האישי';
            break;
        case 'ERROR':
            image = AlertIcon;
            title = 'מצטערים, משהו השתבש ולא ניתן לבצע את הפעולה שביקשת';
            subTitle = 'באפשרותך לנסות שוב או לפנות לשירות הלקוחות';
            btnLink = Config.lobbyUrl;
            btnText = 'חזרה לאיזור האישי';
            displayCallBack = true;
            break;
    }

    function handleOnContinue() {
        EpiContext.navigateTo(btnLink);
    }

    return (
        <div className='customer-service-messages-page' data-error={props.errorDescription}>
        <Image className='icon' src={image} alt={'icon-alert'} />
        {title && <h1 className='page-title'> {title} </h1>}
        {subTitle && <h2 className='page-sub-title'> {subTitle} </h2>}

        {displayCallBack && <div className='call-back-wrapper'>
        <a href={'tel:*'+ window.Config.technicalSupportPhone}>חייגו {window.Config.technicalSupportPhone} לנציג שירות</a>
        </div>}

        {linkText && <a className='link' href='#' onClick={() => prepareUrl(link, EpiContext)}>{linkText}</a>}

        <div className='button-wrapper'>
            <BtnWhiteBlackBorderBigSize text={btnText} onclick={handleOnContinue}/>
        </div>
      </div>
    );

};

const mapStateToProps = (state) => {
  return {
    customerServiceMessageType: state.connectionDetailsBlock.customerServiceMessageType,
    linkJoinToService: state.connectionDetailsBlock.epiData.linkJoinToService,
  };
};

const mapDispatchToProps = { setSelectedSubscriber, getIspConnectionDetailsAsync };

export default connect(mapStateToProps, mapDispatchToProps)(CustomerServiceMessagesPage);
